import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://necdyjchgvntanhhomhg.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_ui3Bl7a_Op4PMRc4-XQtzQ_9tkE-8Z3';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
